import ToastMessage from 'components/basic/ToastMessage';
// import {UseListProps, UseUpdateMutateParams, useGetList} from 'ra-core';
import {BaseRecord, UseListProps as UseListPropsRefine, useList} from '@refinedev/core';
import {QueryObserverOptions, UseMutationOptions, UseQueryOptions} from '@tanstack/react-query';
import {useSearchParams} from 'react-router-dom';
import {toast} from 'react-toastify';

type UseListProps = UseListPropsRefine<BaseRecord, unknown, BaseRecord>;

///////////// default react-query //////////////////////////
export const defaultMutationOptions: UseMutationOptions<any, any, any, any> = {
  onError(error: any, variables, context) {
    const error_data = error?.data || error;
    let details;
    if (error_data.validator_errors) {
      details = (
        <>
          {error_data.validator_errors.map((v, i) => (
            <p key={i}>{v}</p>
          ))}
        </>
      );
    } else if (error_data.errors) {
      details = (
        <>
          {Object.keys(error_data.errors).map((k, i) => (
            <p key={k}>{error_data.errors[k].join(';')}</p>
          ))}
        </>
      );
    } else if (error_data.message) {
      details = <p>{error_data.message}</p>;
    }

    console.error('Mutated error', error_data);
    toast(<ToastMessage message="Lỗi khi lưu dữ liệu" type="error" details={details} />);
  },
  onSuccess(data, variables, context) {
    console.log('Mutated success', data);
    toast(<ToastMessage message="Lưu dữ liệu thành công" type="success" />);
    // toast(<Typography>Lưu dữ liệu thành công</Typography>, {});
  },
};

export const defaultQueryOptions: QueryObserverOptions<any, any, any, any> = {
  refetchOnWindowFocus: false,  
  retry(failureCount, error) {
    if (error.status === 403) return false; // don't retry on 403 errors
    return failureCount < 1; // retry up to 3 times for other errors
  },
  onError(error: any) {
    let details;
    error = error.data || error; //get error data
    if (error.validator_errors) {
      details = (
        <>
          {error.validator_errors.map((v, i) => (
            <p key={i}>{v}</p>
          ))}
        </>
      );
    } else if (error.message) {
      details = <p>{error.message}</p>;
    }

    console.error('Erro occurred', error);

    if (error.message === 'Unauthenticated.') window.location.reload(); //reload to redirect

    toast(<ToastMessage message="Lỗi khi lấy dữ liệu" type="error" details={details} />);
  },
};

//////////// default value when create /////////////////
export const useDefaultValues = () => {
  const [params] = useSearchParams();
  const json = params.get('default');
  const defaultValues = json ? JSON.parse(json) : null;
  return defaultValues;
};

//////////// get resource list ////////////////////
export const useDepartmentList = (params?: Partial<UseListProps>) =>
  useList({
    resource: 'departments',
    sorters: [{field: 'name', order: 'asc'}, ...(params?.sorters || [])],
    filters: params?.filters,
    pagination: {current: 0, pageSize: 9999, ...params?.pagination},
  });

export const useJobList = (params?: Partial<UseListProps>) =>
  useList({
    resource: 'jobs',
    sorters: [{field: 'title', order: 'asc'}, ...(params?.sorters || [])],
    filters: params?.filters,
    pagination: {current: 0, pageSize: 9999, ...params?.pagination},
  });

export const useCategoryList = (params?: Partial<UseListProps>) =>
  useList({
    resource: 'categories',
    sorters: [{field: 'name', order: 'asc'}, ...(params?.sorters || [])],
    filters: params?.filters,
    pagination: {current: 0, pageSize: 9999, ...params?.pagination},
  });

////////////// transform before submit /////////////////
export function convertManyToManyField(data, fieldName) {
  if (!data?.[fieldName]) return data;
  // many-to-many normalize
  data[fieldName] = (data[fieldName] || []).map(c => c.id);
  if (data[fieldName].length === 0) data[fieldName] = '[]';
  return data;
}

export function convertArrayField(arr) {
  if (!arr) return '[]'; // return empty array if null
  if (Array.isArray(arr) && arr.length === 0) return '[]'; // return empty array if empty array
  return arr; // return array if not empty
}
